module.exports = __webpack_public_path__ + "static/media/airport.042a2e09.jpg";